import React, { useState,useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";   
import CommonAPI from '../../Common/CommonAPI';
import FadeLoader from "react-spinners/HashLoader"; 
import ActiveSTODetailPage from "./ActiveStoDetails"; 
import moment from 'moment';
import { Table } from 'react-bootstrap';
import downloadpng from "../../images/download.png";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function ActiveSTO (props) {    

    const [STOActiveDetail,setSTOActiveDetail] = useState(false);
    const [SuccessLoading,setSuccessLoading] = useState(false);
    const [SelectFromAll,setSelectFromAll] = useState({});
    const [FromAccountList,setFromAccountList] = useState([]);
    const [SelectFromAccount,setSelectFromAccount] = useState("");
    const [EnteredBeneName,setEnteredBeneName] = useState("");
    const [STOList,setSTOList] = useState([]);
    const [ SuccessDownload,setSuccessDownload] = useState(false);
    const GetAccountsAPI = () =>{
        CommonAPI.FromToAccountAPI((results) =>{   
            if(results){                    
              setFromAccountList(results.data.mapAccountList?results.data.mapAccountList:null);
            }            
        });
      } 
      useEffect( () => {       
        GetAccountsAPI();  
        GetActiveSTOAPI();
      },[])  ;

      const GetActiveSTOAPI =  (val)=>{
        setSuccessLoading(true)
        CommonAPI.GetActiveSTOSummary({accountNum:val},(results) =>{   
            if( results){                    
                setSTOList(results) 
                setSuccessLoading(false);                           
            }
            if(results.message==="Invalid Request!"){
                setSuccessLoading(false);    
                console.log("Invalid Request!");
              }
        });
    }

      const SelectFromOnChange = (event) => {
        var passValFrom = JSON.parse(event.target.value);    
        setSelectFromAll(JSON.parse(event.target.value));
        setSelectFromAccount(passValFrom.accountNo?passValFrom.accountNo:null); 

        if(passValFrom.accountNo||passValFrom===" "){
        GetActiveSTOAPI(passValFrom.accountNo); 
        }       
     }
    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }
      const SaveHisDetails = (Values)=>{
        var StandOrder= {
          id: Values.id,
        }
        var value = JSON.stringify(StandOrder);
        sessionStorage.setItem('ActiveStandHis', value );
        setSTOActiveDetail(true)
      }

      const STOActiveDetailToggleModal = () => {
        setSTOActiveDetail(!STOActiveDetail);
        GetActiveSTOAPI();

    }
    const printDocument =()=>{
        return (
        <Modal
            size="xl"
            centered         
            onHide={()=>setSuccessDownload(!SuccessDownload)}       
            aria-labelledby="contained-modal-title-vcenter"        
            backdrop="static"
            show={SuccessDownload}> 
    
         <Modal.Header closeButton>
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
            <p className='modal-head-f'>ACTIVE</p><br/>STANDING ORDERS
            </Modal.Title>
            <div>
                <img className='downlogo' onClick ={DownloadDocument.bind(this)} src={downloadpng} alt="download" />
            </div>
          </Modal.Header>
          
          <Modal.Body>
                    
                <Row lg={12} className='div-background'>
                    <Col lg={12} className='rmv-pad3 block text-color'>
    
                    <Table id="divToPrint" className='block-top' hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width4'>No</th>
                            <th className='td-width4'>Reference Number</th>
                            <th className='td-width4'>Transfer Start</th>
                            <th className='td-width4'>Frequency</th>
                            <th className='td-width4'>Transfer End</th>
                            <th className='td-width4'>Beneficiary</th>
                            <th className='td-width4' >Amount Rs.</th>
                            <th className='td-width4'> Beneficiary Account </th>
                            <th className='td-width4'>Last Transfer </th>
                            
                            </tr>
                        </thead>
                        <tbody className='heightTable'>
                        {STOList.length>0?STOList.map(( listValue, index ) => {
                       return( 
                        <tr>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{index+1}{(listValue.branch==="WEB")?" W":"  "}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{listValue.stnoRef}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{moment(listValue.startDate).format('DD/MM/YYYY')}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{listValue.frequency?listValue.frequency:"-"}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{listValue.endDate?moment(listValue.endDate).format('DD/MM/YYYY'):"U.F.N"}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{listValue.beneName}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{parseFloat(listValue.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'> {listValue.bankAccNo}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top'>{listValue.lastDate?moment(listValue.lastDate).format('DD/MM/YYYY'):"-"}</p>
                            </td>                            
                                                              
                        </tr>
                       )
                        }):
                        <Row className='tablebody'>
                            <p className='h-text block-top'>No Records</p>
                        </Row>
                    }  
                        </tbody>
                    </Table>
                    </Col>
                </Row>
            
        </Modal.Body>        
        </Modal>
            );
        }

    const DownloadDocument =()=> {
        
        const input = document.getElementById('divToPrint');
        html2canvas(input)
          .then((canvas) => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;
            var position = 0;
  
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', [290, 210]);
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                 position = heightLeft - imgHeight;
                 pdf.addPage();
                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                 heightLeft -= pageHeight;
               }
            //pdf.output('dataurlnewwindow');
            pdf.save("ActiveStandingOrders.pdf");
          })
        ;
       }
    if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }
        return (
            <div>
                {SuccessDownload?printDocument():null}
                <Row className='block'>
                    <p className='p-line2'>ACTIVE STANDING ORDERS</p>
                </Row>
                {STOActiveDetail?
                <ActiveSTODetailPage isOpen={STOActiveDetail} toggle={STOActiveDetailToggleModal} />
                :null
                }
                <Form >                       
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label className="c-font" column sm={2}>
                                ACCOUNT NUMBER
                            </Form.Label>
                            <Col sm={4} >
                                <Form.Select 
                                    size="sm"                         
                                    className="form-h2 "
                                    value={JSON.stringify(SelectFromAll)}
                                    onChange={SelectFromOnChange}
                                    >
                                        <option value={JSON.stringify(" ")}>Select</option>
                                        {FromAccountList?FromAccountList.map((listValue,index)=>{
                                            return (
                                            <option  key={index} value={JSON.stringify(listValue)}>
                                            Account Number : {listValue.accountNo} | Available Balance : LKR {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                            </option>)
                                        }):
                                        null
                                    }                              
                                </Form.Select>
                            </Col>
                            <Col sm={6} className="d-flex justify-content-end" >                                
                                <img className='downlogo' onClick ={()=>setSuccessDownload(true)} src={downloadpng} alt="download" />
                            </Col>

                        </Form.Group>                      
                    </Form>
                    <Table className='block-top' hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width8 t-left'>No<p></p></th>
                            <th className='td-width4 t-left'>Reference<br/> Number</th>
                            <th className='td-width4 t-left'>Transfer<br/> Start</th>
                            <th className='td-width5 t-left'>Frequency<p></p></th>
                            <th className='td-width5 t-left'>Transfer End <p></p></th>
                            <th className='td-width5 t-right'>Beneficiary<p></p></th>
                            <th className='td-width4 t-right' >Amount Rs.<p></p></th>
                            <th className='td-width2 t-right'> Bene. Account<p></p> </th>
                            <th className='td-width4 t-right'>Last<br/> Transfer </th>
                            <th ><div className='td-width10 t-right'></div>  </th>
                            </tr>
                        </thead>
                        <tbody >
                        {STOList.length>0?STOList.map(( listValue, index ) => {
                       return( 
                        <tr>
                            <td className='td-width8'>
                                <p className='tb-text m-top t-left'>{index+1}{(listValue.branch==="WEB")?" W":"  "}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top t-left'>{listValue.stnoRef}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top t-left'>{moment(listValue.startDate).format('DD/MM/YYYY')}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top t-left'>{listValue.frequency?listValue.frequency:"-"}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top t-left'>{listValue.endDate?moment(listValue.endDate).format('DD/MM/YYYY'):"U.F.N"}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top t-right'>{listValue.beneName}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top t-right'>{parseFloat(listValue.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                            </td>
                            <td className='td-width2'>
                                <p className='tb-text m-top t-right'> {listValue.bankAccNo}</p>
                            </td>
                            <td className='td-width4'>
                                <p className='tb-text m-top t-right'>{listValue.lastDate?moment(listValue.lastDate).format('DD/MM/YYYY'):"-"}</p>
                            </td>                            
                            <td className='td-width10 t-right'>
                                <Button 
                                onClick={()=>{SaveHisDetails(listValue)}}
                                className='btn-browse' 
                                variant="primary" type="submit">
                                    Details
                                </Button>
                            </td>                                     
                        </tr>
                       )
                        }):
                        <tr  className='tr-h'>
                            <td colspan="10"><p className='t-center block-top'>No Records</p></td>
                        </tr>
                    }  
                        </tbody>
                    </Table>
                    
                    <div className='d-flex flex-column align-items-start block'>
                    <p className='tb-text t-left'>U.F.N - Until Further Notice</p>
                    <p className='tb-text s-top'>W - Standing Orders Done through Web</p>   
                    </div>          
            </div>
        );
    }

export default ActiveSTO;